import { FC, useEffect, ReactNode, Fragment } from 'react';
import { useSelector } from 'react-redux';
import { getAlert } from 'modules/alert';
import { TypeEnum, useNotifier } from '@picsart/rc/old/Notifier';
import { ALERT_LIVING_TIME } from 'constants/alert';
import { useTranslator } from '@picsart/rc/services/localization';

type NotifierMessagesProviderProps = {
  children: ReactNode;
};
export const NotifierMessageProvider: FC<NotifierMessagesProviderProps> = ({ children }) => {
  const addNotification = useNotifier();
  const alert = useSelector(getAlert);
  const translator = useTranslator();

  useEffect(() => {
    if (!alert || !alert.message) return;

    addNotification({
      duration: ALERT_LIVING_TIME,
      message: translator(alert.message),
      hasClose: true,
      title: translator(alert.title),
      type: TypeEnum.error
    });
  }, [alert]);

  return <Fragment>{children}</Fragment>;
};
